module.exports = __webpack_public_path__ + "static/media/yagmur.be2ce8ad.jpg";